<template>
  <div class="m-reward-dialog dialog">
    <div class="flex-box">
      <div class="left">
        <div class="input-box">
          <el-input size="small" type="number" disabled v-model="rewardInfo.rewardAmount">
            <template slot="prepend">悬赏金额</template>
          </el-input>
        </div>
        <div class="input-box">
          <el-input size="small" type="number" disabled v-model.number="rewardRemain">
            <template slot="prepend">剩余金额</template>
          </el-input>
        </div>
        <div class="input-box">
          <el-input size="small" type="number" :min="0.01" :max="rewardRemain" v-model.number="giveMoney">
            <template slot="prepend">打赏金额</template>
          </el-input>
        </div>
        <el-button type="warning" :loading="loading" @click="giveReward" size="mini">打赏</el-button>
      </div>
    </div>
    <div class="tip-box">
      <pre>
悬赏说明：
1.如果希望群友回答自己的问题，可以发起一个悬赏主题。
2.发布悬赏金额必须大于1元，可手动设置的悬赏金额作为奖励给予答者。</pre
      >
    </div>
  </div>
</template>
<script>
import Pay from "@/api/pay";
export default {
  data() {
    return {
      giveMoney: 1,
      loading: false,
      url: "",
      orderId: "",
      base64: ""
    };
  },
  computed: {
    rewardRemain() {
      return (this.rewardInfo.rewardAmount * 100 - this.rewardInfo.rewardAmountOut * 100) / 100 || 0;
    }
  },
  methods: {
    async giveReward() {
      await Pay.giveReward({
        msgId: this.giveInfo.msgId,
        amount: this.giveMoney
      }).then(() => {
        this.$toast.success("打赏成功");
        this.$router.go(0);
        this.$emit("update:visible", false);
      });
    }
  },
  props: {
    visible: Boolean,
    giveInfo: Object,
    rewardInfo: Object
  },
  mounted() {
    this.giveMoney = this.rewardRemain;
  }
};
</script>
<style lang="scss">
.m-reward-dialog {
  position: relative;
  .flex-box {
    display: flex;
    padding-bottom: 20px;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      flex-direction: column;
      width: 60%;
      p {
        margin-top: 0;
        margin-bottom: 5px;
      }
    }
    .right {
      margin-left: 20px;
      border-left: 1px solid #eee;
    }
  }
  .left {
    .el-button + .el-button {
      margin-top: 5px;
      margin-left: 0;
    }
  }
  .qrcode-box {
    img {
      width: 100%;
    }
  }
}
</style>
